import useTranslation from 'next-translate/useTranslation'
import { useForm } from 'react-hook-form'
import { useEffect } from 'react'
import { FormBuilder } from '../../../forms/FormBuilder'

type DefaultRegistrationFormProps = {
  formFields
  defaultValues
  onSubmit
  errorMessage: string
  title: string
  description: string
  notifyFormIsDirty: () => void
}
export const DefaultRegistrationForm = ({
  formFields,
  defaultValues,
  onSubmit,
  errorMessage,
  title,
  description,
  notifyFormIsDirty,
}: DefaultRegistrationFormProps) => {
  const { t, lang } = useTranslation('register')

  const {
    register,
    control,
    trigger,
    reset,
    setValue,
    getValues,
    getFieldState,
    handleSubmit,
    formState: { isValid, errors, isDirty },
  } = useForm<any>({
    mode: 'onChange',
    shouldFocusError: true,
    defaultValues: defaultValues,
  })

  useEffect(() => {
    reset(defaultValues)
  }, [formFields])

  useEffect(() => {
    notifyFormIsDirty()
  }, [isDirty])

  return (
    <FormBuilder
      _register={register}
      _setValue={setValue}
      _getValues={getValues}
      _control={control}
      _trigger={trigger}
      _errors={errors}
      _handleSubmit={handleSubmit}
      _isValid={isValid}
      _getFieldState={getFieldState}
      _fields={formFields}
      _defaultValues={defaultValues}
      _onSubmit={onSubmit}
      _submitText={t('RegisterPage.submit')}
      _errorMessage={errorMessage}
      _isMultiStepForm
      _multiStepFormFirstStepText={title ? title : t('RegisterPage.firstStepText')}
      _multiStepFormFirstStepDescription={description ? description : t('RegisterPage.firstStepDescription')}
      _multiStepFormLastStepText={t('RegisterPage.lastStepText')}
    />
  )
}
